import $ from 'jquery';

const SearchForm = () => {
  $(document).on('submit', '[data-search-form]', (e) => {
    const $form = $(e.currentTarget);
    const $input = $form.find('[data-search-input]');
    
    let query = $input.val();
    $form.find('[data-search-raw]').val(query);

    if ($input[0].hasAttribute('data-prepend')) {
      query = $input.data('prepend') + query;
    }

    if ($input[0].hasAttribute('data-append')) {
      let condition = $input.data('condition');
      
      if (condition) {
        condition = ` ${condition}`;
      }
      query = `${query}${condition} ${$input.data('append')}`;
    }

    $form.find('[data-search-query]').val(query);

    return true;
  });
};

export {
  SearchForm,
};